"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Exported promotion forecast converter.
 *
 * @author VRu
 */


var ExportedPromotionForecastConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ExportedPromotionForecastConverter, _DataObjectConverter_);

  function ExportedPromotionForecastConverter() {
    _classCallCheck(this, ExportedPromotionForecastConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPromotionForecastConverter).apply(this, arguments));
  }

  return ExportedPromotionForecastConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ExportedPromotionForecastConverter = ExportedPromotionForecastConverter;